/* eslint-disable */
import React, { useState, useEffect } from "react";
import useUserContext from "../../../hooks/useUserContext";
import { Outlet, useNavigate, NavLink } from "react-router-dom";
import { MAGIC_NUMBERS } from "../../../constant";
import { Total } from "./AppLocationCard";
import getImpactMarketData from "./getImpactMarketData";
import getAllImpactStats from "../dashboard/getAllImpactStats";
import notify from "../../../services/toast";

function classNames(...classes) {
	return classes.filter(Boolean).join(" ");
}

const MARKET_ROUTE_OVERRIDES = {
	central_florida: "tampa_bay",
};

function AllLocations() {
	const navigate = useNavigate();
	const queryParams = new URLSearchParams(window.location.search);
	const type = queryParams.get("type") || "";

	const tabs = [
		{ name: "All", value: "", end: true },
		{ name: "Give", value: "give" },
		{ name: "Boost", value: "boost" },
		{ name: "Community Partner", value: "Community Partner" },
	];

	const { userState } = useUserContext();
	const [marketData, setMarketData] = useState([]);
	const [isMarketDataLoading, setIsMarketDataLoading] = useState(true);
	const [isStatsLoading, setIsStatsLoading] = useState(false);
	const [dashStats, setStats] = useState({});
	const [years, setYears] = useState(["All"]);
	const [selectedYear, setSelectedYear] = useState("All");

	const handleNavigate = (url) => {
		navigate(`/dashboard/locations?type=${url}`);
	};

	const fetchMarketData = async () => {
		const query = selectedYear !== "All" ? `?year=${selectedYear}` : "";
		const response = await getImpactMarketData(userState.accessToken, query);

		if (response.status === "success") {
			const { stats, years } = response.data;
			const filteredYears = years.filter((year) => typeof year === "number" && year !== 1969);
			setMarketData(stats);
			setYears(["All", ...filteredYears]);
		} else {
			notify("Failed to fetch market stats", "error");
		}
		setIsMarketDataLoading(false);
	};

	const fetchStats = async () => {
		const query = selectedYear !== "All" ? `?year=${selectedYear}` : "";
		const response = await getAllImpactStats(userState.accessToken, query);

		if (response.status === "success") {
			setStats(response.data);
		} else if (response.status === "fail") {
			let displayMessage = Array.isArray(response.message)
				? response.message[0].message
				: response.message;

			if (MAGIC_NUMBERS.SERVER_ERROR_CODES.includes(response.statusCode)) {
				displayMessage =
					"An error has occurred. Please try again later. If this error persists please contact support";
			}

			notify(displayMessage, "error");
		}
		setIsStatsLoading(false);
	};

	useEffect(() => {
		fetchMarketData();
		fetchStats();
	}, [type, selectedYear]);

	return (
		<>
			<div className="bg-gray-100 max-w-7xl rounded-3xl shadow-xl p-6 sm:p-8 space-y-8">
				{/* Header */}
				<div className="space-y-2">
					<h1 className="text-3xl font-bold text-gray-800">Scholarship Overview</h1>
					<p className="text-xl font-semibold text-gray-600">All Cities</p>
				</div>

				{/* Year Filter */}
				<section>
					<h2 className="text-lg font-semibold text-gray-800 mb-3">Filter by Year</h2>
					<div className="flex flex-wrap gap-2">
						{years.map((year) => (
							<button
								key={year}
								onClick={() => setSelectedYear(year)}
								className={classNames(
									"px-4 py-2 rounded-lg font-medium transition",
									selectedYear === year
										? "bg-primary-500 text-white shadow-md"
										: "bg-gray-200 text-gray-800 hover:bg-primary-500 hover:text-white"
								)}
							>
								{year}
							</button>
						))}
					</div>
				</section>

				{/* Tabs Navigation */}
				<section className="mb-6">
					{/* Mobile Select */}
					<div className="sm:hidden mb-4">
						<label htmlFor="tabs" className="sr-only">
							Select a tab
						</label>
						<select
							id="tabs"
							name="tabs"
							className="block w-full rounded-lg border-gray-300 focus:ring-primary-400 focus:border-primary-400"
							defaultValue={type || ""}
							onChange={(evt) => handleNavigate(evt.target.value)}
						>
							{tabs.map((tab) => (
								<option key={tab.name} value={tab.value}>
									{tab.name}
								</option>
							))}
						</select>
					</div>
					{/* Desktop Tabs: evenly spaced */}
					<div className="hidden sm:flex w-full bg-white rounded-lg shadow overflow-hidden">
						{tabs.map((tab) => {
							const isActive = tab.value === type;
							return (
								<button
									key={tab.name}
									onClick={() => handleNavigate(tab.value)}
									className={classNames(
										"flex-1 py-3 text-sm font-medium transition-colors duration-200 relative",
										isActive
											? "bg-primary-500 text-white shadow-inner"
											: "bg-white text-gray-700 hover:bg-primary-50 hover:text-primary-600"
									)}
								>
									{tab.name}
									{isActive && (
										<span className="absolute bottom-0 left-0 w-full h-1 bg-primary-700 rounded-t-full"></span>
									)}
								</button>
							);
						})}
					</div>
				</section>
				{/* Totals / Metrics */}
				<section>
					<Total
						marketData={marketData}
						type={type}
						dashstats={dashStats}
						marketRouteOverrides={MARKET_ROUTE_OVERRIDES}
					/>
				</section>
			</div>

			<Outlet />
		</>
	);
}

export default AllLocations;